import styled from 'styled-components';
import { textStyles, token } from '@bynder/design-system';

export const Name = styled.span`
    ${textStyles.uiTextM};
    color: ${token.gray800} !important;
    text-overflow: ellipsis;
    white-space: nowrap;
    width: 100%;
`;

export const Page = styled.span`
    ${textStyles.uiTextS};
    color: ${token.gray600} !important;
    text-overflow: ellipsis;
    white-space: nowrap;
    width: 100%;
`;

export const PageItemStyled = styled.div`
    display: flex;
    gap: ${token.spacing4};

    & > :first-child > :first-child {
        flex-shrink: 0;
    }
`;

export const PageData = styled.div`
    display: flex;
    flex-direction: column;
    overflow: hidden;
`;
